export const L10N = {
  LABEL_COUNTDOWN: { id: 'common.label.countdown' },
};
